import Swal, { SweetAlertOptions } from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

// Base configuration to match the premium dark/clean UI of the app
const baseConfig: SweetAlertOptions = {
  customClass: {
    popup: 'rounded-2xl shadow-2xl',
    confirmButton: 'bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-6 rounded-lg shadow-md transition-colors',
    cancelButton: 'bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-6 rounded-lg transition-colors ml-3'
  },
  buttonsStyling: false,
  // SweetAlert2 v11 dropped the JS `zIndex` option - its container's
  // z-index (default 1060, below our app modals that use z-[9999], e.g. the
  // Replace Question modal) is overridden via CSS instead, see
  // styles/tailwind.css (.swal2-container). Without it, calling
  // Alert.confirm/success while one of those modals is open rendered the
  // SweetAlert popup invisibly behind it - a stuck/confusing no-op click.
};

export const Alert = {
  success: (title: string, text?: string) => {
    return MySwal.fire({
      ...baseConfig,
      icon: 'success',
      title: title,
      text: text,
      showConfirmButton: false, // Hide the OK button for success
      timer: 2000,              // Auto-close after 2 seconds
      timerProgressBar: true,   // Show a nice progress bar at the bottom
    });
  },
  
  error: (title: string, text?: string) => {
    return MySwal.fire({
      ...baseConfig,
      icon: 'error',
      title: title,
      text: text,
      confirmButtonText: 'OK',
    });
  },

  warning: (title: string, text?: string) => {
    return MySwal.fire({
      ...baseConfig,
      icon: 'warning',
      title: title,
      text: text,
      confirmButtonText: 'OK',
    });
  },

  info: (title: string, text?: string) => {
    return MySwal.fire({
      ...baseConfig,
      icon: 'info',
      title: title,
      text: text,
      confirmButtonText: 'OK',
    });
  },

  confirm: (title: string, text: string, confirmText: string = 'Yes, do it!') => {
    return MySwal.fire({
      ...baseConfig,
      icon: 'question',
      title: title,
      text: text,
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: 'Cancel',
      reverseButtons: true
    });
  }
};
